import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cdnURL } from "@inspire/util/cdn";
var CDNImage = function(props) {
    var src = props.src, rest = _object_without_properties(props, [
        "src"
    ]);
    return /*#__PURE__*/ _jsx("img", _object_spread({
        src: cdnURL(src)
    }, rest));
};
export default CDNImage;
